import Vue from 'vue';
import vuetify from './vuetify';
import ConfirmDialog from '@/components/Dialog/ConfirmDialog.vue';
import store from '@/store';
let GlobalPlugins = {};

const DialogConstructor = Vue.extend({
  vuetify,
  ...ConfirmDialog
});
const instance = new DialogConstructor();
instance.$mount();
document.body.appendChild(instance.$el);

GlobalPlugins.install = function (Vue) {
  Vue.prototype.$confirmDialog = function(config) {
    return instance.open(config);
  }

  Vue.prototype.$copyLink = function(link, text="已複製連結") {
    console.log('stroe', store)
    navigator.clipboard.writeText(link)
      .then(() => {
        store.commit('global/UPDATE_MESSAGE_BOX', { active: true, type: 'success', content: text });
      })
      .catch(() => {
        store.commit('global/UPDATE_MESSAGE_BOX', { active: true, type: 'error', content: '複製失敗' });
      });
  }
  Vue.prototype.$downloadXml = function(url = '/api/export-ids-xml', data) {
    // **業務組別(1) + 醫事機構代號(10)  + 上傳年月 (5) + 流水號 (3) + IDS.xml**
    // 輸出範例: 1 3501200000 11307 001IDS.xml
    const formData = new Blob([JSON.stringify(data)], { type: 'application/json' });
    const apiUrl = process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BACKEND + url
    fetch(apiUrl, {
      method: 'POST',
      body: formData,
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      if (!res.ok) throw new Error('下載失敗');
      return res.blob();
    }).then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      const now = new Date();
      const year = now.getFullYear().toString().slice(2);
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const bizCode = '1'; // 業務組別固定值
      const serial = '001'; // 流水號固定值

      a.href = url;
      a.download = `${bizCode}${data.hospid}${year}${month}${serial}IDS.xml`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }).catch((err) => {
      console.error('下載錯誤：', err);
    });
  }
}

export default GlobalPlugins